// @ts-nocheck

import { reduce } from 'lodash';

import type { BasketItems } from '../states/basket';
import { BasketItemStatuses } from '../types/basket';
import type { BasketItemStatus } from '../types/basket';

export const isStatusIsValidatedOrWaitingOrRejected = (status: BasketItemStatus): boolean =>
  status === BasketItemStatuses.VALIDATED ||
  status === BasketItemStatuses.WAITING ||
  status === BasketItemStatuses.REJECTED;

export const hasAtLeastOneValidatedOrWaitingOrRejected = (items: BasketItems): boolean => {
  return reduce(items, (acc, { status }) => acc || isStatusIsValidatedOrWaitingOrRejected(status), false);
};

const BREAK_LINES_LIMIT = 35;

export const isLabelsTooLong = (labels: Array<string | null> | string, limit: number | null): boolean => {
  let nbCharacters = 0;
  if (Array.isArray(labels)) {
    nbCharacters = labels.reduce((acc, cur) => acc + (cur?.length || 0), 0);
  } else {
    nbCharacters = labels?.length || 0;
  }
  const nbCharactersLimit = limit || BREAK_LINES_LIMIT;
  return nbCharacters > nbCharactersLimit;
};
